import React, {
	useState,
	useMemo,
	useEffect,
	useCallback,
	useContext,
	useRef,
} from "react";
import { Loader } from "../../CoreUI";
import { motion } from "framer-motion";

import TrackerWrapper from "../../TrackerWrapper";

import useResource from "../../../hooks/useResource";

import getApiUrl from "../../../utils/getApiUrl";
import GET from "../../../utils/GET";

import "./module-preview.css";
import OfferSurface from "../../Surfaces/OfferSurface";
import { SURFACE_DATA_KEY } from "../../../conf";
import CustomPostSurface from "../../Surfaces/CustomPostSurface";
import SurveySurface from "../../Surfaces/SurveySurface";
import anim from "../../../utils/anim";
import { SurfaceDimensionsContext } from "../../SurfaceManager";

const moduleID = GET("customPreviewID");
const publisher = GET("publisher");

export default React.memo(
	({ defaultData, moduleType = "", remoteKey = "", moduleDataMapper }) => {
		const [moduleData, setModuleData] = useState(defaultData);
		const [customLoading, setCustomLoading] = useState(true);
		const [showFullCard, setShowFullCard] = useState(true);

		const rootRef = useRef(null);
		const { innerHeight, offsetTop } = useContext(SurfaceDimensionsContext);
		const onClose = useCallback(() => {
			return;
		}, []);

		const defaultModuleProps = useMemo(
			() => ({
				surfaceData: moduleData[SURFACE_DATA_KEY[moduleType]],
				data: moduleData,
				idx: -1,
				active: true,
				preview: true,
				handleSurfaceClose: onClose,
				showFullCard,
				rootRef,
			}),
			[moduleData, onClose, moduleType, showFullCard]
		);

		const [
			{ data, loading, error },
			fetchPreviewData,
			,
			,
			resetPreviewData,
		] = useResource(
			`${getApiUrl()}/core/module_preview/${publisher}/`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					module_type: moduleType,
					module_id: moduleID,
				}),
			},
			false
		);

		const handleScroll = useCallback(() => {
			if (!rootRef?.current) {
				return;
			}
			const scroll = rootRef.current.scrollTop;
			if (scroll > 10) {
				setShowFullCard(false);
			} else {
				setShowFullCard(true);
			}
		}, []);

		useEffect(() => {
			// if (!moduleID) {
			// 	setCustomLoading(false);
			// 	return;
			// }
			fetchPreviewData();
		}, [fetchPreviewData]);

		useEffect(() => {
			if (data) {
				setCustomLoading(false);
				setModuleData((moduleData) => ({
					...data,
					[remoteKey]: {
						...(moduleDataMapper(data, moduleData) ||
							data[remoteKey]),
					},
				}));
				resetPreviewData();
			}
			if (error) {
				setCustomLoading(false);
			}
		}, [data, resetPreviewData, error, moduleDataMapper, remoteKey]);

		if (error) {
			return null;
		}

		return (
			<TrackerWrapper data={moduleData}>
				<motion.section
					className="module-preview-container"
					style={{
						top: `${offsetTop}px`,
						height: `${innerHeight}px`,
						// backgroundColor: customColor
						// 	? customColor
						// 	: // desktop
						// 	  // 	? `${customColor}ee`
						// 	  // 	: customColor
						// 	  "auto",
					}}
					ref={rootRef}
					onScroll={handleScroll}
					variants={anim.surfaceManager}
					initial="initial"
					animate="animate"
					exit="exit"
				>
					{loading || customLoading ? (
						<Loader center />
					) : moduleType === "offer" ? (
						<>
							<OfferSurface {...defaultModuleProps} />
						</>
					) : moduleType === "survey" ? (
						<>
							<SurveySurface {...defaultModuleProps} />
						</>
					) : moduleType === "custom_post" ? (
						<>
							<CustomPostSurface {...defaultModuleProps} />
						</>
					) : null}
				</motion.section>
			</TrackerWrapper>
		);
	}
);
